import { ENV_CONFIG } from "env-config";

class API {
	login() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/admin/exists`;
	}

	getAllStocks() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/list`;
	}

	getServerHealth() {
		return `${ENV_CONFIG.serverURL}/health-check/in/health`;
	}

	getZerodhaLoginUrlAdmin() {
		return `${ENV_CONFIG.serverURL}/livetick/in/v1/url`;
	}

	getLiveTickStatus() {
		return `${ENV_CONFIG.serverURL}/livetick/in/v1/status`;
	}

	createZerodhaConnection() {
		return `${ENV_CONFIG.serverURL}/livetick/in/v1/connect`;
	}

	getMarketQuote(stockId: string) {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/quote?stockId=${stockId}`;
	}

	getRequiredMargin() {
		return `${ENV_CONFIG.serverURL}/user-context/in/v1/required-margin`;
	}

	getAllAccounts() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/accounts`;
	}

	getBrokerLoginUrl(userId: string) {
		return `${ENV_CONFIG.serverURL}/user-context/in/v1/url?userId=${userId}`;
	}

	submitToken() {
		return `${ENV_CONFIG.serverURL}/user-context/in/v1/create`;
	}

	kotalLogin() {
		return `${ENV_CONFIG.serverURL}/user-context/in/v1/kotak/login`;
	}

	disconnectBroker(userId: string) {
		return `${ENV_CONFIG.serverURL}/user-context/in/v1/clear/${userId}`;
	}

	getNotifications(page: number) {
		return `${ENV_CONFIG.serverURL}/notifications/in/v1/all?page=${page}`;
	}

	updateAccountSettings() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/update-config`;
	}

	getAllOrders() {
		return `${ENV_CONFIG.serverURL}/order/in/v1/list`;
	}

	placeOrder() {
		return `${ENV_CONFIG.serverURL}/order/in/v1/place-order`;
	}

	modifyOrder() {
		return `${ENV_CONFIG.serverURL}/order/in/v1/modify-order`;
	}

	cancelOrder(orderId: string) {
		return `${ENV_CONFIG.serverURL}/order/in/v1/cancel-order?orderId=${orderId}`;
	}

	getWebSocketApiUrl() {
		return ENV_CONFIG.serverURL + "/mimic-ws";
	}

	saveAccount() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/add`;
	}

	updateAccount() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/update-credentials`;
	}

	getUser(userId: string) {
		return `${ENV_CONFIG.serverURL}/user/in/v1/user?userId=${userId}`;
	}

	addOrRemoveChild() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/add-remove`;
	}

	changeMaster(accountId: string) {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/change/master-account?accountId=${accountId}`;
	}

	up() {
		return `${ENV_CONFIG.serverURL}/user/in/v1/account/add-remove`;
	}

	uploadFnoInstruments() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/upload-instruments/fno`;
	}
	uploadEquityInstruments() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/upload-instruments/equity`;
	}
	updateFnoInstruments() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/update-instruments/fno`;
	}
	updateEquityInstruments() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/update-instruments/equity`;
	}
	getFno() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/list/fno`;
	}
	getEquities() {
		return `${ENV_CONFIG.serverURL}/stock/in/v1/list/equity`;
	}
}

export default new API();
